exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chapter-tree[data-v-0f66cf89]::-webkit-scrollbar{width:6px}.chapter-tree[data-v-0f66cf89]  .el-tree-node__content{height:36px}", ""]);

// exports
